import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import {langs, messages} from '@/locales';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: getBrowserLanguage(),
  fallbackLocale: getBrowserLanguage(),
  messages,
});

export function setI18nLanguage(lang: string) {
  i18n.locale = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;

  if (document != null) {
    const $html = document.querySelector('html');

    if ($html != null) {
      $html.setAttribute('lang', lang);
    }
  }

  return lang;
}

function getBrowserLanguage() {
  const languages = langs;
  const browserLanguage = navigator.language.replace('-', '_');

  if (languages.includes(browserLanguage)) { return browserLanguage; }

  for (const language of languages) {
    if (language.substring(0, 2) === browserLanguage.substring(0, 2)) { return language; }
  }

  return 'en_US';
}
